import { render, staticRenderFns } from "./QaListItemPublishActions.vue?vue&type=template&id=1d650834&scoped=true&"
import script from "./QaListItemPublishActions.vue?vue&type=script&lang=js&"
export * from "./QaListItemPublishActions.vue?vue&type=script&lang=js&"
import style0 from "./QaListItemPublishActions.vue?vue&type=style&index=0&id=1d650834&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d650834",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VTextarea})
